import React from 'react';
import { FieldValues } from 'react-hook-form';
import { Link } from 'react-router-dom';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import type { SubsectionRouterProps } from '../../components/Router/SubsectionRouterProps';
import { SummaryAnswers } from '../../components/SummaryAnswers/SummaryAnswers';
import Tag from '../../components/Tag/Tag';
import { Question } from '../../config/types';
import { useFormConfig } from '../../hooks/useFormConfig';
import { useFormData } from '../../hooks/useFormData';
import type { FetchFormResponse } from '../../service/types';
import { Status } from '../../types';
import {
  getSelectedConditionalQuestions,
  isJsonObject,
  isPageCompleted,
  renderAnswer,
} from '../../utils/config-utils';

function SummaryScreen({ subsection, sectionTitle, sectionName, urlPath }: SubsectionRouterProps) {
  const { enabledSubsections } = useFormConfig();
  const { pages } = enabledSubsections[subsection.slug];

  return (
    <PageTemplate
      breadcrumbs={{ sectionName, sectionTitle }}
      title={sectionTitle}
      subTitle={sectionName}
      fullWidth
    >
      <div className="govuk-body" style={{ marginBottom: '1em' }}>
        You may exit this form at any time; your submitted answers will be saved.
      </div>
      <SummaryAnswers pages={pages} subsection={subsection} urlPath={urlPath} displayTitle />
    </PageTemplate>
  );
}

export default SummaryScreen;
